<template>
  <v-card flat>
    <v-card-text>
      <v-list>
        <v-list-item v-for="member in workspace.members" :key="member.id" rounded>
          <v-list-item-avatar>
            <v-img :src="member.avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="member.name"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon small @click="removeUser(member.id)">
              <v-icon small>close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-list v-if="workspaceInvites" dense>
        <v-divider></v-divider>
        <v-subheader>Pending Invites</v-subheader>
        <v-list-item v-for="invite in workspaceInvites" :key="invite.id" rounded>
          <v-list-item-content>
            <v-list-item-title v-text="invite.toEmail"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn v-if="sentInvites.includes(invite.id)" small color="primary" text disabled>
              <v-icon small>send</v-icon>Sent</v-btn
            >
            <v-btn v-else small color="primary" @click="reInvite(invite)" text>
              <v-icon small>send</v-icon>Re-Send
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn small @click="changeStatus({ inviteId: invite.id, status: 'revoked' })" text>
              <v-icon small>close</v-icon>Revoke
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <invite-users-form
        class=""
        :typeAheadList="[]"
        :dropDownList="[]"
        :workspace="workspace"
        actionLabel="Send Invite"
        title="Invite Members"
        label="Enter email addresses to invite to this workspace"
        @inviteUsers="inviteUsers"
        @inviting="inviting = true"
        @notInviting="inviting = false"
      ></invite-users-form>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="!inviting" text @click="$emit('done')">Done</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InviteUsersForm from '@/components/SettingsModal/InviteUsersForm';
export default {
  props: ['workspace'],
  components: { InviteUsersForm },
  data() {
    return {
      inviting: false,
      usersToRemove: [],
      sentInvites: []
    };
  },
  mounted() {
    this.subscribeToInvites({ workspaceId: this.workspace.id });
  },
  destroyed() {
    this.unsubscribeToInvites();
  },
  computed: {
    ...mapGetters('workspaces', ['collaboratorDirectory']),
    ...mapGetters('invites', ['workspaceInvites'])
  },
  methods: {
    ...mapActions('auth', ['getUserByEmail', 'sendInvite']),
    ...mapActions('invites', ['subscribeToInvites', 'unsubscribeToInvites', 'changeStatus']),
    ...mapActions('workspaces', ['addWorkspaceMember', 'removeWorkspaceMember']),
    inviteUsers(users) {
      users.map(user => {
        try {
          console.log(user);
          //  individually add new members
          //  user is { id, avatar, name }
          this.addWorkspaceMember({ workspaceId: this.workspace.id, user });
        } catch (e) {
          console.log(e);
        }
      });
    },
    removeUser(authorId) {
      this.removeWorkspaceMember({ workspaceId: this.workspace.id, authorId });
    },
    needsSaving: function() {
      return this.usersToRemove.length > 0 || this.saving;
    },
    reInvite(invite) {
      this.sendInvite({
        email: invite.toEmail,
        workspace: invite.workspace,
        inviteId: invite.id
      }).then(() => this.sentInvites.push(invite.id));
    }
  }
};
</script>

<style></style>
